export default "__VITE_ASSET__C_0WUWca__"